module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_nordland_neg.e5834373.pdf";